export default {
  p01_ako_ucit_dieta: require('./p01_ako_ucit_dieta').default,
  p02_kroky_k_uspechu: require('./p02_kroky_k_uspechu').default,
  p03_vyvin_pohyb: require('./p03_vyvin_pohyb').default,
  p04_o_odnimani_zodpovednosti: require('./p04_o_odnimani_zodpovednosti')
    .default,
  p05_zdrava_strava: require('./p05_zdrava_strava').default,
  p06_koreny_zavislosti: require('./p06_koreny_zavislosti').default,
  p07_mozek_jsme_my: require('./p07_mozek_jsme_my').default,
  p08_telo_a_mozek: require('./p08_telo_a_mozek').default,
  p09_co_jedia: require('./p09_co_jedia').default,
  p10_v_ucitelskych_monterkach: require('./p10_v_ucitelskych_monterkach')
    .default,
  c01_encounter: require('./c01_encounter').default,
  c02_panelova_diskusia: require('./c02_panelova_diskusia').default,
  c03_workshops_sobota: require('./c03_workshops_sobota').default,
  c05_workshops_nedela: require('./c05_workshops_nedela').default,
  c04_pecha_kucha: require('./c04_pecha_kucha').default,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/index.js